import MultiSelectDropdown from "../../../Atoms/DropDowns/MultiSelectDropdown";
import CustomDropdown from "../../../Atoms/DropDowns/CustomDropdown";
import IconAndTextButton from "../../../Atoms/Buttons/IconAndTextButton";
import crossIcon from "../../../../assets/Icon-area-16.svg";
import { useEffect, useState } from "react";
import { useAgent } from "../../../../contexts/AgentsContext";
import SkillsSec from "./SkillsSec";
import { CircularProgress } from "@mui/material";
import "../../css/classif.sec.css";
import AgentBusinessFuncSec from "./AgentBusinessFuncSec";
const DefineAgentClass = ({ type }) => {
  const {
    ongoingAgentData,
    updateOngoingAgentDataL3,
    isLoadingDropdownFields,
    lookUpValues,
    fetchAgentSectorsSilently,
    isInitializingEdit,
  } = useAgent();

  const [industrySectors, setIndustrySectors] = useState([
    { id: 1, industry: "", sector: [] },
    { id: 2, industry: "", sector: [] },
    { id: 3, industry: "", sector: [] },
  ]);

  const [isSectorValuesFetching, setIsSectorValuesFetching] = useState([
    { index: null, isFetching: false },
  ]);

  const handleIndustryChange = async (index, value) => {
    setIsSectorValuesFetching((prev) => {
      const filtered = prev.filter((item) => item.index !== index);
      return [...filtered, { index, isFetching: true }];
    });

    try {
      const sectorsFromAPI = await fetchAgentSectorsSilently(value);

      const updatedSectors = industrySectors.map((item, i) =>
        i === index
          ? { industry: value, sectorValues: sectorsFromAPI, sector: [] }
          : item
      );

      setIndustrySectors(updatedSectors);
    } finally {
      setIsSectorValuesFetching((prev) => {
        const filtered = prev.filter((item) => item.index !== index);
        return [...filtered, { index, isFetching: false }];
      });
    }
  };

  const handleSectorChange = (index, value) => {
    const updatedSectors = industrySectors.map((item, i) =>
      i === index ? { ...item, sector: value } : item
    );

    setIndustrySectors(updatedSectors);
    updateOngoingAgentDataL3("industry_info", updatedSectors);
  };

  const handleRemoveIndustry = (indexToRemove) => {
    if (industrySectors?.length > 1) {
      const updatedSectors = industrySectors.filter(
        (_, index) => index !== indexToRemove
      );

      setIndustrySectors(updatedSectors);
      updateOngoingAgentDataL3("industry_info", updatedSectors);
    }
  };

  const handleAddIndustry = () => {
    const newBlankRow = { industry: "", sector: [], sectorValues: [] };
    const updatedSectors = [...industrySectors, newBlankRow];

    setIndustrySectors(updatedSectors);
  };

  useEffect(() => {
    if (type === "edit") {
      setIndustrySectors(
        ongoingAgentData?.classifications?.[0]?.industry_info || []
      );
    }
  }, [ongoingAgentData?.classifications, type]);

  return (
    <article className="mas-agent-form-classification">
      <div className="d-flex align-items-center">
        <div className="def-sol-cls-sub-hdr">
          Industry and Sector Information
        </div>

        {(isLoadingDropdownFields?.industries || isInitializingEdit) && (
          <CircularProgress
            style={{
              width: "15px",
              height: "15px",
              opacity: 0.8,
              marginLeft: "5px",
            }}
          />
        )}
      </div>
      <section className="mt-3">
        <div
          className="mas-industries-sector mb-2"
          style={
            isInitializingEdit || isLoadingDropdownFields?.industries
              ? { opacity: 0.3, pointerEvents: "none" }
              : {}
          }
        >
          <div className="d-flex">
            <div className="wd-4 fw-bold">#</div>
            <div className="wd-36 ps-3 fw-bold">Select Industry</div>
            <div className="wd-58 ps-3 fw-bold">Select Sector</div>
            <div className="wd-2"></div>
          </div>

          <div className="mb-2">
            {industrySectors?.map((item, index) => (
              <div className="d-flex" key={index}>
                <div className="wd-4 d-flex align-items-center">
                  <span className="mas-numbering">{index + 1}</span>
                </div>
                <div className="wd-36 pd">
                  <CustomDropdown
                    selectValues={lookUpValues?.industries?.map((industry) => ({
                      value: industry,
                      label: industry,
                    }))}
                    value={item?.industry || ""}
                    handleOnChange={(value) =>
                      handleIndustryChange(index, value)
                    }
                    dropdownLabel={"Select/Type to Search"}
                    clsNames={"mas-multiselect-dd-primary mas-cust-dd-2"}
                  />
                </div>
                <div className="wd-58 pd">
                  <MultiSelectDropdown
                    selectValues={item?.sectorValues?.map((sector) => ({
                      value: sector,
                      label: sector,
                    }))}
                    values={item?.sector || []}
                    handleOnChange={(values) =>
                      handleSectorChange(index, values)
                    }
                    dropdownLabel="Select/Type to Search"
                    clsNames="mas-multiselect-dd-primary mas-multi-dd-2"
                    disabled={
                      !item?.sectorValues?.length ||
                      isSectorValuesFetching.some(
                        (fetchItem) =>
                          fetchItem.index === index && fetchItem.isFetching
                      )
                    }
                  />
                </div>
                <div className="wd-2 d-flex align-items-center justify-content-end pe-2">
                  {isSectorValuesFetching.find(
                    (item) => item.index === index && item.isFetching
                  ) ? (
                    <CircularProgress
                      style={{
                        width: "16px",
                        height: "16px",
                        opacity: 0.8,
                      }}
                    />
                  ) : (
                    <IconAndTextButton
                      icon={<img src={crossIcon} alt="Remove" />}
                      text=""
                      iconPos="right"
                      iconStyles={{
                        width: 16,
                        height: 16,
                        opacity: industrySectors.length === 1 ? 0.3 : 1,
                        cursor:
                          industrySectors.length === 1
                            ? "not-allowed"
                            : "pointer",
                      }}
                      clsNames="mas-cross-icon-btn"
                      onClickFn={() => {
                        if (industrySectors.length > 1) {
                          handleRemoveIndustry(index);
                        }
                      }}
                      disabled={industrySectors.length === 1}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        <IconAndTextButton
          icon={<span style={{ fontSize: 20 }}>+</span>}
          text="Add Industry"
          iconPos="left"
          iconStyles={{ fontSize: 20, marginRight: 4 }}
          clsNames="mas-plus-icon-btn mb-2"
          onClickFn={handleAddIndustry}
        />
      </section>

      <section className="wd-50 mb-2">
        <AgentBusinessFuncSec />
      </section>

      <SkillsSec />
    </article>
  );
};

export default DefineAgentClass;
